
import React from 'react';

const LockSVG = () =>
  <svg height="53px" width="53px" version="1.1" viewBox="0 0 53 53">
    <g fill="none" stroke="none" strokeLinecap="square" strokeWidth="1">
      <g transform="translate(-195.000000, -258.000000)">
        <g transform="translate(157.000000, 115.000000)">
          <g transform="translate(-1.000000, 107.000000)">
            <g transform="translate(39.000000, 29.000000)">
              <g transform="translate(0.000000, 7.000000)">
                <path d="M52.5091,26.2545 C52.5091,11.7545 40.7551,0.0005 26.2551,0.0005 C11.7551,0.0005 0.0001,11.7545 0.0001,26.2545 C0.0001,40.7545 11.7551,52.5085 26.2551,52.5085 C40.7551,52.5085 52.5091,40.7545 52.5091,26.2545" fill="#ECECEC"/>
                <g transform="translate(16.000000, 11.000000)">
                  <polygon fill="#FFFFFF" points="0.144 26.2871 20.366 26.2871 20.366 8.9541 0.144 8.9541"/>
                  <polygon points="0.144 26.2871 20.366 26.2871 20.366 8.9541 0.144 8.9541" stroke="#222228" strokeWidth="1.5"/>
                  <path d="M16.0325,8.9533 L16.0325,6.0643 C16.0325,2.8733 13.4455,0.2863 10.2545,0.2863 C7.0635,0.2863 4.4765,2.8733 4.4765,6.0643 L4.4765,8.2313" stroke="#222228" strokeWidth="1.5"/>
                  <path d="M13.1434,16.1759 C13.1434,14.5799 11.8504,13.2869 10.2544,13.2869 C8.6594,13.2869 7.3654,14.5799 7.3654,16.1759 C7.3654,17.2419 7.9504,18.1629 8.8104,18.6639 L8.8104,21.9529 L11.6994,21.9529 L11.6994,18.6639 C12.5594,18.1629 13.1434,17.2419 13.1434,16.1759 Z" stroke="#EC5424" strokeWidth="1.5"/>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>;

export default LockSVG;


// WEBPACK FOOTER //
// ./src/svg/LockSVG.js